// extracted by mini-css-extract-plugin
export default {"allProjects":"AllProjects_allProjects__JVa1e","dataProjLinkParent":"AllProjects_dataProjLinkParent__3qRcL","dataProjLink":"AllProjects_dataProjLink__s80E7"};